/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IColumnas from './entidades/columnas';
import IFiltrosColumnas from './entidades/filtrosColumnas';

export default class ModeloColumnas {
    public consultarColumnas() {
        return manejadorRest<IRespuesta<IColumnas>>(() => negocioConfiguracion.get('Columna/ConsultarListaColumna'), true);
    }
    public crearColumnas(columnas: IColumnas) {
        return manejadorRest<IRespuesta<IColumnas>>(() => negocioConfiguracion.post('Columna/GuardarColumna', columnas), true);
    }
    public editarColumnas(columnas: IColumnas) {
        return manejadorRest<IRespuesta<IColumnas>>(() => negocioConfiguracion.put('Columna/EditarColumna', columnas), true);
    }
    public eliminarColumnas(columnas: IColumnas) {
        return manejadorRest<IRespuesta<IColumnas>>(() => negocioConfiguracion.delete('Columna/EliminarColumna', columnas), true);
    }
    public consultarListaColumnasPorFiltro(filtrosColumnas: Partial<IFiltrosColumnas>) {
        return manejadorRest<IRespuesta<IColumnas>>(
            () => negocioConfiguracion.post('Columna/ConsultarListaColumnaPorFiltro', filtrosColumnas),
            true
        );
    }
}
